/* eslint-disable relay/must-colocate-fragment-spreads */
/* eslint eslint-comments/no-use: off */
/* eslint-disable relay/unused-fields */
/* To avoid a circular dependency between the timeline-items and issue viewer packages we can not colocate the fragments or put the fields next to where they are used. */

import {type PreloadedQuery, useQueryLoader} from 'react-relay'
import {graphql} from 'relay-runtime'

import type {secondaryTimelineQuery} from './__generated__/secondaryTimelineQuery.graphql'

export type PreloadedSecondaryQueryType = PreloadedQuery<secondaryTimelineQuery>
export const SecondaryTimelineGraphqlQuery = graphql`
  query secondaryTimelineQuery($nodes: [ID!]!) {
    nodes(ids: $nodes) {
      ... on ReferencedEvent {
        __id
        commit {
          ...ReferencedEventVerificationStatusInner
        }
      }
    }
  }
`
export function useSecondaryTimelineQuery() {
  const [secondaryTimelineQueryRef, loadSecondaryTimelineQueryRef, dispose] =
    useQueryLoader<secondaryTimelineQuery>(SecondaryTimelineGraphqlQuery)

  return {
    secondaryTimelineQueryRef,
    loadSecondaryTimelineQueryRef,
    dispose,
  }
}
